// extracted by mini-css-extract-plugin
export default {"filtersItemContainer":"styles_filtersItemContainer__rY6nU","filtersItem":"styles_filtersItem__ZAkpm"};